const app = {
  state: {
    // 面包屑数组
    breadCrumbList:[{
      path: "/index",
      name: "index",
      meta: {
        title: "首页"
      }
    },{
      path: "",
      name: "",
      meta: {
        title: ""
      }
    }],

    //天正设备码
    tz:{
      //开机码
      onCode:['0001','1001','1101'],
      //关机码
      offCode:['0000','1000','1100'],
      //设备eid
      eid:{
        wsd:['5','15'], //温湿度传感器
        wsy:['4'],    //温湿盐传感器
        sw :['24'],   //水位传感器
      }
    },

    //websocket消息
    wsMessage:null,

    //侧边导航 索引
    navActiveIndex:1,
    //区域ID
      areaId:'',
      areaName:'',
      userName:'用户名',
    routeTo:''
  },
  mutations: {
    setRouteTo(state, res){
      state.routeTo = res;
    },
    setAreaId(state, res)
    {
        if(res.areaId && state.areaId != res.areaId){
            state.areaId = res.areaId;
        }
        if(res.areaName && state.areaName != res.areaName){
            state.areaName = res.areaName;
        }
    },
    setWsMessage(state, res){
      state.wsMessage = res;
    },
    setBreadCrumb (state, route) {
      state.breadCrumbList.splice(1,1);
      state.breadCrumbList.push({
        path: route.path,
        name: route.name,
        meta: {
          title: route.title
        }
      })
    },
    //改变侧边导航 索引
    setNavActiveIndex(state, index){
      state.navActiveIndex = index;
    }
  }
};

export default app;
